"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.form.title.edit': 'Edit Step',
    'step.form.title.add': 'Add Step',
    'step.form.back': 'Back',
    'step.form.title.label': 'Title',
    'step.form.title.placeholder': 'Step title',
    'step.form.order.label': 'Order',
    'step.form.order.placeholder': 'Step order',
    'step.form.isShared.label': 'Shared Step',
    'step.form.profession.label': 'Profession',
    'step.form.profession.placeholder': 'Select profession',
    'step.form.description.label': 'Description',
    'step.form.description.placeholder': 'Enter step description',
    'step.form.questions.title': 'Questions',
    'step.form.questions.add': 'Add Question',
    'step.form.questions.remove': 'Remove',
    'step.form.questions.empty': 'No questions added yet. Click "Add Question" to get started.',
    'step.form.questions.order': 'Question',
    'step.form.submit.update': 'Update Step',
    'step.form.submit.create': 'Create Step',
    'step.form.profession.shared': 'Shared Step (No Profession)',
    'step.form.professions.loadError': 'Failed to load professions',
    'step.form.load.error': 'Failed to load step',
    'step.form.question.changed.debug': 'Question changed:',
    'step.form.action.updated': 'updated',
    'step.form.action.created': 'created',
    'step.form.submit.updateSuccess': 'Step updated successfully',
    'step.form.submit.success': 'Step {action} successfully',
    'step.form.submit.failed': 'Step failed to be {action}',
    'step.form.submit.updateError': 'Failed to update step',
    'step.form.submit.createError': 'Failed to create step',
};
